import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Category } from '../models/category';
import { iHttpPaginatedResponse } from '../interfaces/iHttpPaginatedResponse';

@Injectable({
  providedIn: 'root'
})

export class CategoryService {

    constructor(private http: HttpClient) {
    }

    public getCategories(): Observable<Category[]> {
        return this.http.get<Category[]>(environment.apiEndpoint + `/api/category`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getPaginatedCategories(page, pp): Observable<iHttpPaginatedResponse> {
      return this.http.get<iHttpPaginatedResponse>(environment.apiEndpoint + `/api/admin/category?page=${page}&pp=${pp}`).pipe(
          map(res => {
              return res;
          })
      );
    }

    public getCategory(category_id:number): Observable<any> {
        return this.http.get<any>(environment.apiEndpoint + `/api/category/${category_id}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getCategoryCourses(category_id:number): Observable<any> {
        return this.http.get<any>(environment.apiEndpoint + `/api/category/courses/${category_id}`).pipe(
            map(res => {
                return res;
            })
        );
    }

    public getAllCategoryCourses(category_id:number): Observable<any> {
      return this.http.get<any>(environment.apiEndpoint + `/api/category/coursesAll/${category_id}`).pipe(
          map(res => {
              return res;
          })
      );
  }

    public addNewCategory(): Observable<any>{
      return this.http.post(environment.apiEndpoint + '/api/admin/category', {name: 'New category', media_id: 1}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }

    public updateCategory(category:Category): Observable<any>{
      return this.http.put(environment.apiEndpoint + '/api/admin/category/' + category.id, {category:category}).pipe(
        map(
          res=>{
            return res;
          }
        )
      );
    }
}